/** Only retain a canonical activity detail path, never arbitrary URLs or tokens. */
export function activityReturnTo(value: unknown): string | null {
  return typeof value === 'string' && /^\/activity\/[1-9]\d{0,9}$/.test(value) ? value : null
}

export function safeReturnTo(value: unknown): string | null {
  return value === '/check-in' ? '/check-in' : activityReturnTo(value)
}

export function loginLocation(
  target: { path?: string; query?: Record<string, unknown> },
  name: 'Login' | 'AdminLogin' = 'Login',
) {
  const redirect = safeReturnTo(target.path)
    || (target.path === '/login' || target.path === '/admin-login' || target.path === '/complete-profile'
      ? safeReturnTo(target.query?.redirect) : null)
  return redirect ? { name, query: { redirect } } : { name }
}

export function postLoginPath(redirect: unknown, home: string): string {
  return safeReturnTo(redirect) || home
}
